import { useState, useEffect } from "react";
import FunctionalButton from "components/layout/FunctionalButton";
import AnimatedModal from "components/layout/motion/AnimatedModal";

const LandmarkEditDialog = ({ visible, landmark, onSave, onClose }) => {
    const [name, setName] = useState("");

    // Initialize name when landmark changes
    useEffect(() => {
        if (landmark) {
            setName(landmark.name);
        }
    }, [landmark]);

    const handleSave = () => {
        onSave({ name });
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSave();
        } else if (e.key === "Escape") {
            onClose();
        }
    };

    return (
        <AnimatedModal
            visible={visible}
            onClose={onClose}
            className="w-96 rounded-r5 bg-black100 p-6"
        >
            <h2 className="mb-4 text-lg text-white">Edit Landmark</h2>

            <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={handleKeyDown}
                className="mb-4 w-full rounded-r5 bg-black80 px-3 py-2 text-white"
                placeholder="Landmark name"
                autoFocus
            />

            <div className="flex justify-end space-x-2">
                <FunctionalButton title="Cancel" onClick={onClose} className="bg-black60" />
                <FunctionalButton title="Save" onClick={handleSave} className="bg-primary2" />
            </div>
        </AnimatedModal>
    );
};

export default LandmarkEditDialog;
